// extracted by mini-css-extract-plugin
module.exports = {"root":"KbdBadge_root__po0dj","label":"KbdBadge_label__ZyQZ0"};